
import { Question } from '../types';

export const taj101PracticalExamplesQuestions: Question[] = [
  {
    id: 'taj091',
    text: 'In the word مَالِك (mālik) in Sūrah al-Fātiḥah, which type of madd is present?',
    type: 'single',
    options: [
      { id: 'a', text: 'Madd aṣlī', isCorrect: true },
      { id: 'b', text: 'Madd muttaṣil', isCorrect: false },
      { id: 'c', text: 'Madd munfaṣil', isCorrect: false },
      { id: 'd', text: 'Madd ʿāriḍ', isCorrect: false }
    ],
    explanation: 'In مَالِك (mālik), the alif is a letter of madd preceded by a fatḥah. Since there is no hamzah or sukūn after the alif, it is madd aṣlī, which is elongated for the duration of one alif.',
    topic: 'taj101'
  },
  {
    id: 'taj092',
    text: 'In the phrase إِنَّا أَعْطَيْنَاكَ (innā aʿṭaynāka) from Sūrah al-Kawthar, identify all the types of madd present:',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Madd aṣlī in نَا of أَعْطَيْنَاكَ', isCorrect: true },
      { id: 'b', text: 'Madd muttaṣil', isCorrect: false },
      { id: 'c', text: 'Madd munfaṣil between إِنَّا and أَعْطَيْنَاكَ', isCorrect: true },
      { id: 'd', text: 'Madd līn in عَيْ of أَعْطَيْنَاكَ', isCorrect: true }
    ],
    explanation: 'In this phrase, we have madd aṣlī in the نَا of أَعْطَيْنَاكَ, madd munfaṣil between إِنَّا and أَعْطَيْنَاكَ (where the alif at the end of إِنَّا is followed by a hamzah in the next word), and madd līn in عَيْ of أَعْطَيْنَاكَ (where the yāʾ sākinah is preceded by a fatḥah).',
    topic: 'taj101'
  },
  {
    id: 'taj093',
    text: 'In the word الرَّحْمٰنِ (ar-raḥmān) from Sūrah al-Fātiḥah, identify the correct tafkhīm/tarqīq applications:',
    type: 'multiple',
    options: [
      { id: 'a', text: 'The rāʾ (ر) is read with tafkhīm', isCorrect: true },
      { id: 'b', text: 'The lām (ل) is read with tarqīq', isCorrect: true },
      { id: 'c', text: 'The nūn (ن) is read with tafkhīm', isCorrect: false },
      { id: 'd', text: 'The alif (ا) after the ḥāʾ (ح) is read with tarqīq', isCorrect: true }
    ],
    explanation: 'In الرَّحْمٰنِ: The rāʾ (ر) has a fatḥah, so it is read with tafkhīm. The lām (ل) is not in the word Allah, so it is read with tarqīq. The nūn (ن) is always read with tarqīq. The alif after the ḥāʾ is read with tarqīq because the ḥāʾ is not a letter of istiʿlāʾ.',
    topic: 'taj101'
  },
  {
    id: 'taj094',
    text: 'When reciting مِنْ شَرِّ (min sharri) from Sūrah al-Falaq, which rule is applied to the nūn sākinah?',
    type: 'single',
    options: [
      { id: 'a', text: 'Idghām with ghunnah', isCorrect: true },
      { id: 'b', text: 'Ikhfāʾ', isCorrect: false },
      { id: 'c', text: 'Iṭh-hār', isCorrect: false },
      { id: 'd', text: 'Iqlāb', isCorrect: false }
    ],
    explanation: 'In مِنْ شَرِّ (min sharri), the nūn sākinah is followed by the letter shīn (ش), which is one of the letters of idghām with ghunnah (يَنْمُو). The nūn sākinah is assimilated into the shīn and pronounced with a nasal sound (ghunnah).',
    topic: 'taj101'
  },
  {
    id: 'taj095',
    text: 'In the verse وَمِنْ شَرِّ غَاسِقٍ (wa min sharri ghāsiqin) from Sūrah al-Falaq, identify the correct tajweed rules applied:',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Idghām with ghunnah between نْ and ش in مِنْ شَرِّ', isCorrect: true },
      { id: 'b', text: 'Iṭh-hār for the نْ before غ in شَرِّ غَاسِقٍ', isCorrect: true },
      { id: 'c', text: 'The غ in غَاسِقٍ is read with tafkhīm', isCorrect: true },
      { id: 'd', text: 'The ق in غَاسِقٍ is read with tarqīq', isCorrect: false }
    ],
    explanation: "This verse contains: idghām with ghunnah between نْ and ش in مِنْ شَرِّ, iṭh-hār for the نْ before غ in شَرِّ غَاسِقٍ (as غ is a throat letter), tafkhīm for the غ in غَاسِقٍ (as it's a letter of istiʿlāʾ), and tafkhīm for the ق in غَاسِقٍ (not tarqīq, as ق is also a letter of istiʿlāʾ).",
    topic: 'taj101'
  },
  {
    id: 'taj096',
    text: 'In the phrase قُلْ أَعُوذُ (qul aʿūdhu) from the beginning of Sūrah al-Falaq, which tajweed rule occurs between the two words?',
    type: 'single',
    options: [
      { id: 'a', text: 'Iṭh-hār', isCorrect: true },
      { id: 'b', text: 'Ikhfāʾ', isCorrect: false },
      { id: 'c', text: 'Idghām', isCorrect: false },
      { id: 'd', text: 'Iqlāb', isCorrect: false }
    ],
    explanation: 'In قُلْ أَعُوذُ (qul aʿūdhu), the lām sākinah in قُلْ is followed by a hamzah in أَعُوذُ. Since the hamzah is a throat letter, the rule of iṭh-hār applies, meaning the lām is pronounced clearly without any assimilation or hiding.',
    topic: 'taj101'
  },
  {
    id: 'taj097',
    text: 'In the word إِيَّاكَ (iyyāka) from Sūrah al-Fātiḥah, which rule is being applied to the yāʾ?',
    type: 'single',
    options: [
      { id: 'a', text: 'Tashdīd (gemination)', isCorrect: true },
      { id: 'b', text: 'Madd (elongation)', isCorrect: false },
      { id: 'c', text: 'Ikhfāʾ (hiding)', isCorrect: false },
      { id: 'd', text: 'Qalqalah (disturbance)', isCorrect: false }
    ],
    explanation: "In إِيَّاكَ (iyyāka), the yāʾ has a shadda (tashdīd) on it. This means the yāʾ is geminated or doubled: pronounced as two yāʾs, the first with a sukūn and the second with a fatḥah. This is not madd because the yāʾ here is not a letter of madd (it doesn't have a kasrah before it).",
    topic: 'taj101'
  },
  {
    id: 'taj098',
    text: 'When stopping on the word الْكَافِرُونَ (al-kāfirūna) from Sūrah al-Kāfirūn, how would the last letter be pronounced?',
    type: 'single',
    options: [
      { id: 'a', text: 'With sukūn (الْكَافِرُونْ)', isCorrect: true },
      { id: 'b', text: 'With ḍammah (الْكَافِرُونَ)', isCorrect: false },
      { id: 'c', text: 'With fatḥah (الْكَافِرُونَ)', isCorrect: false },
      { id: 'd', text: 'With kasrah (الْكَافِرُونِ)', isCorrect: false }
    ],
    explanation: 'When stopping on the word الْكَافِرُونَ, the rule of waqf with iskān applies. This means the last letter (nūn) becomes sākin (with sukūn), regardless of what vowel it originally had. So it is pronounced as الْكَافِرُونْ.',
    topic: 'taj101'
  },
  {
    id: 'taj099',
    text: 'In the phrase مَالِكِ يَوْمِ (māliki yawmi) from Sūrah al-Fātiḥah, identify the tajweed rule applied between the two words:',
    type: 'single',
    options: [
      { id: 'a', text: 'There is no specific tajweed rule applied between the words', isCorrect: true },
      { id: 'b', text: 'Idghām', isCorrect: false },
      { id: 'c', text: 'Madd munfaṣil', isCorrect: false },
      { id: 'd', text: 'Ikhfāʾ', isCorrect: false }
    ],
    explanation: 'In مَالِكِ يَوْمِ (māliki yawmi), there is no specific tajweed rule applied between the two words. The كِ at the end of مَالِكِ has a kasrah and the يَ at the beginning of يَوْمِ has a fatḥah. They are simply pronounced normally with their respective vowels.',
    topic: 'taj101'
  },
  {
    id: 'taj100',
    text: 'In the word هُدًى (hudan) from Sūrah al-Baqarah, what does the double fatḥah (tanwīn) at the end indicate?',
    type: 'single',
    options: [
      { id: 'a', text: 'The addition of a nūn sākinah sound (هُدَنْ)', isCorrect: true },
      { id: 'b', text: 'A prolongation of the vowel', isCorrect: false },
      { id: 'c', text: 'A pause at the word', isCorrect: false },
      { id: 'd', text: 'A doubling of the last letter', isCorrect: false }
    ],
    explanation: 'The double fatḥah (tanwīn) at the end of هُدًى indicates the addition of a nūn sākinah sound in pronunciation. So, هُدًى is pronounced as "hudan" (هُدَنْ). Tanwīn means adding a nūn sākinah to the end of nouns.',
    topic: 'taj101'
  }
];
